import { PageLayout, PageTitle } from "../components/PageLayout";

const SectionHeading = ({ children }) => (
  <h2
    className="mt-10 text-[22px] sm:text-[26px]"
    style={{ color: "#1A1A1A", fontWeight: 600, letterSpacing: "0.2px" }}
  >
    {children}
  </h2>
);

const SubHeading = ({ children }) => (
  <h3
    className="mt-6 text-[18px] sm:text-[19px]"
    style={{ color: "#1A1A1A", fontWeight: 600 }}
  >
    {children}
  </h3>
);

const SubSubHeading = ({ children }) => (
  <h4
    className="mt-4 text-[16px] sm:text-[17px]"
    style={{ color: "#1A1A1A", fontWeight: 600 }}
  >
    {children}
  </h4>
);

export default function Datenschutz() {
  return (
    <PageLayout>
      <PageTitle testId="page-datenschutz-title">Datenschutzerklärung</PageTitle>
      <div
        className="mx-auto mt-8 w-full max-w-3xl text-[16px] leading-[1.7] sm:text-[17px]"
        style={{ color: "#1A1A1A" }}
        data-testid="page-datenschutz-body"
      >
        <SectionHeading>1. Datenschutz auf einen Blick</SectionHeading>

        <SubHeading>Allgemeine Hinweise</SubHeading>
        <p className="mt-3">
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit
          Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
          Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
          identifiziert werden können. Ausführliche Informationen zum Thema
          Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>

        <SubHeading>Datenerfassung auf dieser Website</SubHeading>
        <SubSubHeading>
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </SubSubHeading>
        <p className="mt-2">
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis
          zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
        </p>

        <SubSubHeading>Wie erfassen wir Ihre Daten?</SubSubHeading>
        <p className="mt-2">
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein
          Kontaktformular eingeben.
        </p>
        <p className="mt-3">
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch
          der Website durch unsere IT-Systeme erfasst. Das sind vor allem
          technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des
          Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald
          Sie diese Website betreten.
        </p>

        <SubSubHeading>Wofür nutzen wir Ihre Daten?</SubSubHeading>
        <p className="mt-2">
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der
          Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
          geschlossen oder angebahnt werden können, werden die übermittelten Daten
          auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen
          verarbeitet.
        </p>

        <SubSubHeading>Welche Rechte haben Sie bezüglich Ihrer Daten?</SubSubHeading>
        <p className="mt-2">
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
          dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
          Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit
          für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
          bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>
        <p className="mt-3">
          Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich
          jederzeit an uns wenden.
        </p>

        <SubHeading>Analyse-Tools und Tools von Drittanbietern</SubHeading>
        <p className="mt-3">
          Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
          ausgewertet werden. Das geschieht vor allem mit sogenannten
          Analyseprogrammen.
        </p>
        <p className="mt-3">
          Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der
          folgenden Datenschutzerklärung.
        </p>

        <SectionHeading>2. Hosting</SectionHeading>
        <p className="mt-3">Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>

        <SubHeading>IONOS</SubHeading>
        <p className="mt-3">
          Anbieter ist die IONOS SE, Elgendorfer Str. 57, 56410 Montabaur
          (nachfolgend IONOS). Wenn Sie unsere Website besuchen, erfasst IONOS
          verschiedene Logfiles inklusive Ihrer IP-Adressen. Details entnehmen Sie
          der Datenschutzerklärung von IONOS:{" "}
          <a
            href="https://www.ionos.de/terms-gtc/terms-privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline transition-opacity duration-200 hover:opacity-70"
          >
            ionos.de/terms-gtc/terms-privacy
          </a>
          .
        </p>
        <p className="mt-3">
          Die Verwendung von IONOS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
          DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst
          zuverlässigen Darstellung unserer Website. Sofern eine entsprechende
          Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich
          auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG,
          soweit die Einwilligung die Speicherung von Cookies oder den Zugriff
          auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting)
          im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
        </p>

        <SubHeading>Auftragsverarbeitung</SubHeading>
        <p className="mt-3">
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des
          oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen
          datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass
          dieser die personenbezogenen Daten unserer Websitebesucher nur nach
          unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
        </p>

        <SectionHeading>3. Allgemeine Hinweise und Pflichtinformationen</SectionHeading>

        <SubHeading>Datenschutz</SubHeading>
        <p className="mt-3">
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.
        </p>
        <p className="mt-3">
          Wenn Sie diese Website benutzen, werden verschiedene personenbezogene
          Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
          persönlich identifiziert werden können. Die vorliegende
          Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
          sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
        </p>
        <p className="mt-3">
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei
          der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
          möglich.
        </p>

        <SubHeading>Hinweis zur verantwortlichen Stelle</SubHeading>
        <p className="mt-3">
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p className="mt-3">
          Stephan Weiler, agentur weiler<br />
          Baumgartenstraße 90<br />
          34130 Kassel<br />
          Telefon: 01709012068<br />
          E-Mail:{" "}
          <a
            href="mailto:info@outofthewronglife.com"
            className="underline transition-opacity duration-200 hover:opacity-70"
            style={{ color: "#1A1A1A" }}
          >
            info@outofthewronglife.com
          </a>
        </p>
        <p className="mt-3">
          Verantwortliche Stelle ist die natürliche oder juristische Person, die
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o.
          Ä.) entscheidet.
        </p>

        <SubHeading>Speicherdauer</SubHeading>
        <p className="mt-3">
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei
          uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
          berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur
          Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir
          keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
          personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
          Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach
          Fortfall dieser Gründe.
        </p>

        <SubHeading>
          Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf
          dieser Website
        </SubHeading>
        <p className="mt-3">
          Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir
          Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a
          DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien
          nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer
          ausdrücklichen Einwilligung in die Übertragung personenbezogener Daten
          in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage
          von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von
          Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B. via
          Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung
          zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist
          jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur
          Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir
          Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
          verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen
          Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c
          DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres
          berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über
          die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den
          folgenden Absätzen dieser Datenschutzerklärung informiert.
        </p>

        <SubHeading>Empfänger von personenbezogenen Daten</SubHeading>
        <p className="mt-3">
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
          externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung
          von personenbezogenen Daten an diese externen Stellen erforderlich. Wir
          geben personenbezogene Daten nur dann an externe Stellen weiter, wenn
          dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
          gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an
          Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1
          lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige
          Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
          Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden
          nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung
          weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
          gemeinsame Verarbeitung geschlossen.
        </p>

        <SubHeading>Widerruf Ihrer Einwilligung zur Datenverarbeitung</SubHeading>
        <p className="mt-3">
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
          Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>

        <SubHeading>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </SubHeading>
        <p className="mt-3" style={{ textTransform: "none" }}>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F
          DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS
          IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
          AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
          RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
          DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
          IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI
          DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
          NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER
          DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG
          VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
        </p>
        <p className="mt-3">
          WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
          BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
          VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
          DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT
          ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN,
          WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE
          DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
        </p>

        <SubHeading>Beschwerderecht bei der zuständigen Aufsichtsbehörde</SubHeading>
        <p className="mt-3">
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder
          des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht
          unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher
          Rechtsbehelfe.
        </p>

        <SubHeading>Recht auf Datenübertragbarkeit</SubHeading>
        <p className="mt-3">
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder
          an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen
          zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen
          Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
          machbar ist.
        </p>

        <SubHeading>Auskunft, Berichtigung und Löschung</SubHeading>
        <p className="mt-3">
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
          Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung
          dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>

        <SubHeading>Recht auf Einschränkung der Verarbeitung</SubHeading>
        <p className="mt-3">
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
          folgenden Fällen:
        </p>
        <ul className="mt-3 list-disc space-y-2 pl-6">
          <li>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen
            Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu
            überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </li>
          <li>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah / geschieht, können Sie statt der Löschung die Einschränkung
            der Datenverarbeitung verlangen.
          </li>
          <li>
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie
            jedoch zur Ausübung, Verteidigung oder Geltendmachung von
            Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </li>
          <li>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben,
            muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen
            werden. Solange noch nicht feststeht, wessen Interessen überwiegen,
            haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen.
          </li>
        </ul>
        <p className="mt-3">
          Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt
          haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit
          Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung
          von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen
          oder juristischen Person oder aus Gründen eines wichtigen öffentlichen
          Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet
          werden.
        </p>

        <SectionHeading>4. Datenerfassung auf dieser Website</SectionHeading>

        <SubHeading>Cookies</SubHeading>
        <p className="mt-3">
          Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind
          kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an.
          Sie werden entweder vorübergehend für die Dauer einer Sitzung
          (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät
          gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch
          gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis
          Sie diese selbst löschen oder eine automatische Löschung durch Ihren
          Webbrowser erfolgt.
        </p>
        <p className="mt-3">
          Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen
          stammen (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die
          Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb
          von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
        </p>
        <p className="mt-3">
          Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch
          notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren
          würden (z. B. die Warenkorbfunktion oder die Anzeige von Videos). Andere
          Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken
          verwendet werden.
        </p>
        <p className="mt-3">
          Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs,
          zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z. B.
          für die Warenkorbfunktion) oder zur Optimierung der Website (z. B.
          Cookies zur Messung des Webpublikums) erforderlich sind (notwendige
          Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
          gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der
          Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von
          notwendigen Cookies zur technisch fehlerfreien und optimierten
          Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung
          von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt
          wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage dieser
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG); die
          Einwilligung ist jederzeit widerrufbar.
        </p>
        <p className="mt-3">
          Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
          Cookies informiert werden und Cookies nur im Einzelfall erlauben, die
          Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie
          das automatische Löschen der Cookies beim Schließen des Browsers
          aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität
          dieser Website eingeschränkt sein.
        </p>
        <p className="mt-3">
          Sofern weitere Cookies und Dienste auf dieser Website eingesetzt werden,
          können Sie dies dieser Datenschutzerklärung entnehmen.
        </p>

        <SubHeading>Anfrage per E-Mail, Telefon oder Telefax</SubHeading>
        <p className="mt-3">
          Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre
          Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
          (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
          gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
          Einwilligung weiter.
        </p>
        <p className="mt-3">
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
          gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde;
          die Einwilligung ist jederzeit widerrufbar.
        </p>
        <p className="mt-3">
          Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben
          bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
          (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
          gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen
          – bleiben unberührt.
        </p>

        <p
          className="mt-10 text-xs"
          style={{ color: "rgba(26,26,26,0.5)" }}
        >
          Quelle:{" "}
          <a
            href="https://www.e-recht24.de"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            e-recht24.de
          </a>
        </p>
      </div>
    </PageLayout>
  );
}
